import AdditionalField from "../models/module/additionalfield/AdditionalField";
import API from "../services/api";

export default class AdditionalFieldRepository {
    static all = (moduleId) => API.get('/module/additional-field/all?id=' + moduleId).then(response => response.data.additionalfields.map(item => AdditionalField.fromJson(item.additionalField)));
    static get = (id) => API.get('/module/additional-field/details/' + id).then(response => response.data);

    static create = (data) => API.post('/module/additional-field/create', data);
    static update = (data) => API.post('/module/additional-field/update', data).then(response => response.data);
    static toggle = (data) => API.post('/module/additional-field/toggle', data).then(response => response.data.active);
    static updateTree = (data) => API.post('/module/additional-field/update/order', { tree: data });
    static delete = (id) => API.delete('/module/additional-field/delete?id=' + id);
}